import { IDocumentRequestModel } from '../../../interfaces/ICase';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useAddExternalDocumentMutation = () => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (request: IDocumentRequestModel) => {
            const response = await zoneApiClient.addExternalDocuments(request);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to add External Documents');
            }
            return response;
        },
    });
};
